/** Wildlife identities and poses belong to the world, independently of render tiles.
 * Positions below use a fixed tangent frame attached to the rotating planet. */
export type WildlifeVec = [number, number, number];
export type WildlifeActivity = 'idle' | 'walk' | 'graze' | 'drink' | 'alert' | 'flee';
export interface WildlifeFrame { origin: WildlifeVec; right: WildlifeVec; up: WildlifeVec; forward: WildlifeVec }
export interface WildlifeMemberView {
  id: string; x: number; y: number; z: number; yaw: number; speed: number;
  activity: WildlifeActivity; since: number; fear: number; look: WildlifeVec | null;
}
export interface WildlifeHerdView {
  id: string; planet: number; origin: WildlifeVec; members: WildlifeMemberView[];
}
export interface WildlifeMsg { t: 'wildlife'; time: number; herds: WildlifeHerdView[] }
export const WILDLIFE = {
  version: 1, members: 6, activeM: 420, sleepM: 600, detailedM: 110,
  renderM: 180, networkM: 240, maxHerds: 4, walkSpeed: .4267578125, runSpeed: 2.8,
} as const;
export function wildlifeFrame(origin: WildlifeVec): WildlifeFrame {
  const normalize = (v: WildlifeVec): WildlifeVec => { const n = Math.hypot(...v) || 1; return v.map(x => x / n) as WildlifeVec; };
  const up = normalize(origin);
  const right = normalize(Math.abs(up[1]) < .9 ? [-up[2], 0, up[0]] : [0, up[2], -up[1]]);
  const forward: WildlifeVec = [right[1]*up[2]-right[2]*up[1], right[2]*up[0]-right[0]*up[2], right[0]*up[1]-right[1]*up[0]];
  return { origin, right, up, forward };
}
export function wildlifeLocal(frame: WildlifeFrame, p: WildlifeVec): WildlifeVec {
  const d = p.map((v, i) => v - frame.origin[i]);
  return [frame.right, frame.up, frame.forward].map(axis => axis.reduce((n,v,i) => n + v*d[i], 0)) as WildlifeVec;
}
export function wildlifePlanet(frame: WildlifeFrame, x: number, y: number, z: number): WildlifeVec {
  return frame.origin.map((v,i) => v + frame.right[i]*x + frame.up[i]*y + frame.forward[i]*z) as WildlifeVec;
}
